import {Component, ViewChild} from '@angular/core';
import {IonicPage, LoadingController, Nav, NavController, NavParams, Platform} from 'ionic-angular';

import {PlatformExaminationPage} from '../platform-examination/platform-examination';
import {ProofListPage} from '../proof-list/proof-list';
import {HelpPage} from '../help/help';
import {ProofFinishedListPage} from '../proof-finished-list/proof-finished-list';
// import { ProofResponseFeedbackListPage } from '../proof-response-feedback-list/proof-response-feedback-list';
import {SubscriptionListPage} from '../subscription-list/subscription-list';

import {QuizzListPage} from '../quizz-list/quizz-list';

import {UpdateCertificationDocumentPage} from "../update-certification-document/update-certification-document";
import {UpdateTitleDocumentPage} from "../update-title-document/update-title-document";

import {AuthProvider} from '../../providers/auth/auth';
import {AlertProvider} from '../../providers/alert/alert';
import {SystemProvider} from '../../providers/system/system';
import {EventEmitterProvider} from '../../providers/event-emitter/event-emitter';
import {RegistrationProvider} from '../../providers/registration/registration';
import {QuizzServerProvider} from '../../providers/quizz-server/quizz-server';
import {QuizzProvider} from '../../providers/quizz/quizz';

import * as Config from '../../app/app.config';

import {Geolocation} from '@ionic-native/geolocation';
import {NativeGeocoder, NativeGeocoderOptions, NativeGeocoderReverseResult} from '@ionic-native/native-geocoder';
import {HttpClient} from "@angular/common/http";

import {NewSubscription} from '../../models/newsubscription';
import {ChatbotProvider} from '../../providers/chatbot/chatbot';

/**
 * Generated class for the MainPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-main',
  templateUrl: 'main.html',
})
export class MainPage {

  @ViewChild(Nav) nav: Nav;

  version: string = Config.version;
  // Target main page
  rootPage: any = ProofListPage;
  pages: Array<{ title: string, component: any, highlight: string, visible: boolean }>;
  user: any;
  userLocation: any;

  private registrationUpdatedSubscription: any;
  private hasQuizzSubscription: any;
  public newSubscription: NewSubscription;

  constructor(
    public loadingCtrl: LoadingController,
    public navCtrl: NavController,
    public navParams: NavParams,
    private authProvider: AuthProvider,
    private alertProvider: AlertProvider,
    private systemProvider: SystemProvider,
    private eventEmitterProvider: EventEmitterProvider,
    private registrationProvider: RegistrationProvider,
    private geolocation: Geolocation,
    private nativeGeocoder: NativeGeocoder,
    private platform: Platform,
    private http: HttpClient,
    private quizzServerProvider: QuizzServerProvider,
    private quizzProvider: QuizzProvider,
    private chatbotProvider: ChatbotProvider,
  ) {
    this.newSubscription = new NewSubscription();
    let loader = navParams.get('loader');
    if (loader) {
      loader.dismiss();
    }

    this.user = this.authProvider.getUser();
    this.pages = [
      // {title: 'Carteira Profissional', component: IdCardPage, highlight: null, visible: false},
      // {title: 'Atualização Cadastral', component: UpdateRegistrationPage, highlight: this.isRegistrationComplete(), visible: true},
      // {title: 'Documentos Comprobatórios', component: UpdateCertificationDocumentPage, highlight: null, visible: true},
      {title: 'Teste da Plataforma', component: PlatformExaminationPage, highlight: null, visible: false},
      {title: 'Realizar Prova', component: ProofListPage, highlight: null, visible: true},
      {title: 'Meu Desempenho', component: ProofFinishedListPage, highlight: null, visible: true},
      {title: 'Histórico de Provas', component: SubscriptionListPage, highlight: 'default', visible: true},
      {title: 'Documentos de Apoio', component: UpdateTitleDocumentPage, highlight: null, visible: true},
      // {title: 'Gabarito da Prova', component: ProofResponseFeedbackListPage, highlight: null, visible: false},
      {title: 'Certificação Continuada', component: QuizzListPage, highlight: null, visible: false},
      {title: 'Contato', component: HelpPage, highlight: null, visible: true}
    ];

    let that = this;
    this.registrationUpdatedSubscription = this.eventEmitterProvider.get('registration_updated').subscribe((user: any) => {
      that.user = user;
      that.pages[1].highlight = that.isRegistrationComplete();
    });

    this.authProvider.getProof(true).subscribe(data => {

      if (data !== null) {

        let provas = new Array(116, 117, 118, 119, 120, 121);

        // mostra caso tenha sido reprovado
        if (provas.indexOf(data.proofId) != -1 && data.auditStatus !== 'FL') {
          console.log("# PROVA # ");
          console.log(data)

          // doc complementares
          that.pages[3].visible = false;
          // Histórico de Inscrição
          that.pages[4].visible = false;

          // realizar prova
          that.pages[5].visible = false;

          that.rootPage = UpdateCertificationDocumentPage;
        }
      }

    });

    if (Config.quizzEnabled) {
      this.hasQuizzSubscription = this.eventEmitterProvider.get('has_quizz').subscribe(() => {
        that.pages[0].visible = true;
        that.pages[5].visible = true;
        that.rootPage = QuizzListPage;
      });

      // DONE: Detect status of Quizz
      this.quizzServerProvider.getStatus().subscribe((data: any) => {
        // console.log('MainPage.constructor.quizz.getStatus', data);

        if (data) {
          if (data.result === true) {
            switch (data.action) {
              case 'can_contract_quizz':
                that.eventEmitterProvider.get('can_contract_quizz').emit();
                that.quizzServerProvider.setCanContractQuizz(true);
                break;

              case 'has_quizz':
                that.eventEmitterProvider.get('has_quizz').emit();
                break;

              case 'has_quizz_question':
                that.eventEmitterProvider.get('has_quizz').emit();
                that.quizzProvider.doShowQuestion(that.navCtrl, that.navParams);
                break;
            }
          }
        }
      }, (error: any) => {
        // Do nothing.
      });
    }
  }

  ionViewDidLoad() {
    if (Config.baseUrl !== 'https://api.febraban.institutototum.com.br') {
      this.pages.filter(item => item.title === 'Teste da Plataforma')
      .map(item => item.visible = true)
    }
    // console.log('ionViewDidLoad MainPage');
    this.getPosition();
    this.chatbotProvider.init();
  }

  hideMenu(id) {
    return this.pages[id].visible = false;
  }

  showMenu(id) {
    return this.pages[id].visible = true;
  }

  ionViewWillLeave() {
    this.registrationUpdatedSubscription.unsubscribe();

    if (Config.quizzEnabled) {
      this.hasQuizzSubscription.unsubscribe();
    }
  }

  isRegistrationComplete() {
    return this.registrationProvider.isComplete() ? null : 'danger';
  }

  openPage(page: any) {
    let continueToPage = true;

    // // Verify if this registration is complete
    // if ((page.component.name === 'SubscriptionListPage') || (page.component.name === 'ProofListPage') || (page.component.name === 'ProofResponseFeedbackListPage')) {
    //
    //   if (!this.registrationProvider.isComplete()) {
    //     continueToPage = false;
    //
    //     let that = this;
    //
    //     this.alertProvider.doAlert('Você precisa atualizar seu cadastro para poder continuar.', null, (): void => {
    //       that.nav.setRoot(UpdateRegistrationPage);
    //     });
    //   }
    // }

    if (continueToPage) {
      // Reset the content nav to have just this page
      // we wouldn't want the back button to show in this scenario
      this.nav.setRoot(page.component);
    }
  }

  doLogout() {
    let that = this;

    this.alertProvider.doConfirm('Você deseja sair?', () => {
      that.systemProvider.close();
    });
  }

  getPosition() {
    let that = this;

    this.geolocation.getCurrentPosition().then((resp) => {
      let options: NativeGeocoderOptions = {
        useLocale: true,
        maxResults: 1
      };

      if ((this.platform.is('android')) || (this.platform.is('cordova'))) {
        this.nativeGeocoder.reverseGeocode(resp.coords.latitude, resp.coords.longitude, options)
          .then((result: NativeGeocoderReverseResult[]) => {
            that.userLocation = result[0];
          })
          .catch((error: any) => {
            that.userLocation = null;
          });
      } else {
        // this.http.get('https://open.mapquestapi.com/geocoding/v1/reverse?key=eUPn1zjEW0GXmIZtJJ18WeHylWQx4Ail&location=' + resp.coords.latitude + ',' + resp.coords.longitude + '&includeRoadMetadata=true&includeNearestIntersection=true').subscribe((response: Response) => {
        //   try {
        //     let userLocation = (response['results'][0]['locations'][0]['adminArea5']);
        //     that.userLocation = userLocation;
        //   } catch (e) {
        //     // Do nothing.
        //   }
        // });
      }
    }).catch((error) => {
      // console.log('Error getting location', error);
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/main/main.ts